/* unplugin-vue-components disabled */import script from "./PointsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsManager.vue?vue&type=script&setup=true&lang=js"

import "./PointsManager.vue?vue&type=style&index=0&id=65ab4647&lang=scss"

const __exports__ = script;

export default __exports__